import { locateProxy } from '#~/agent/index.js';
import type { Device } from '@studio/models/device';
import { CalibrationActionType } from '@tryiris-ai/common.protojs/agent/v1/agent';

export { CalibrationActionType } from '@tryiris-ai/common.protojs/agent/v1/agent';

/** @internal */
export const calibrate = async (
  deviceId: Device['id'],
  action: CalibrationActionType
): Promise<void> => {
  const proxy = locateProxy(deviceId);

  if (!proxy) {
    throw new Error('SC-330');
  }

  await proxy.mutate(
    {
      control: {
        device: {
          [deviceId]: {
            movement: {
              calibration: {
                action
              }
            }
          }
        }
      }
    },
    {}
  );
};
